<div class="note-header" fxLayout="row" fxLayoutAlign="space-between center">
    <div>
        <!-- <div class="subject" flex>{{note.detail}}</div> -->
        <div fxFlex fxLayout="column" fxLayoutAlign="start start">
            <div fxLayout="row" fxLayoutAlign="start center">
                <div>
                    <div class="avatar" ms-random-class="vm.colors">
                        {{note.note.user?.firstName[0]}}
                    </div>
                </div>
                <div fxLayout="column" fxLayoutAlign="start start">
                  <div class="name" fxLayout="row" fxLayoutAlign="start center" fxFlex>
                    <div class='id' *ngIf="note?.sequenceId">{{note.sequenceId}}</div>
                    <div class='draft' *ngIf="!note?.sequenceId">Draft</div>
                    <span class="pl-8 text-truncate"> - {{note?.note?.user?.fullName || 'Unspecified'}}</span>
                  </div>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="showActions" class="actions" fxLayout="row" fxLayoutAlign="start center">

        <button mat-icon-button class="mat-icon-button" (click)="toggleStar($event)" aria-label="Toggle star"
            matTooltip="Toggle Star" [disabled]="readOnly">
            <mat-icon *ngIf="note.note.starred" class="star">star</mat-icon>
            <mat-icon *ngIf="!note.note.starred">star_outline</mat-icon>
        </button>

        <button mat-icon-button class="mat-icon-button" (click)="toggleImportant($event)" aria-label="Toggle important"
            matTooltip="Toggle Important" [disabled]="readOnly">
            <mat-icon *ngIf="note.note.important" class="important">error</mat-icon>
            <mat-icon *ngIf="!note.note.important">error_outline</mat-icon>
        </button>

        <button mat-icon-button class="mat-icon-button" (click)="toggleSensitive($event)" aria-label="Toggle sensitive"
            matTooltip="Toggle Sensitive" [disabled]="readOnly">
            <mat-icon *ngIf="note.note.sensitive" class="sensitive">lock</mat-icon>
            <mat-icon *ngIf="!note.note.sensitive">lock_open</mat-icon>
        </button>
    </div>

    <div *ngIf="!showActions" class="actions" fxLayout="row" fxLayoutAlign="start center">
        <div fxFlex fxLayout="row" fxLayoutAlign="start center" class="pr-16">
            <div class="time">{{note.note.dateCreated | date: 'dd/MMM/yyyy - hh:mm a'}}</div>
            <div class="time" style="padding-left:10px">{{ ((note.note.noteType?.name.length || 0)>0? '- '+
                note.note.noteType?.name:
                '')}}</div>
        </div>
        <button mat-icon-button [matMenuTriggerFor]="moreMenu" aria-label="More" class="mat-icon-button" matTooltip="More"
            (click)="$event.stopPropagation()">
            <mat-icon>more_vert</mat-icon>
        </button>

        <mat-menu #moreMenu="matMenu">
            <button mat-menu-item aria-label="Copy" [copy-clipboard]="note.note.detail" (copied)="notifyCopied($event)">
                <mat-icon>assignment</mat-icon>
                <span>Copy</span>
            </button>

            <button mat-menu-item aria-label="Print" (click)="print($event)">
                <mat-icon>print</mat-icon>
                <span>Print</span>
            </button>
        </mat-menu>
    </div>
</div>

<div class="note-content" [ngStyle]="{'height':height}">
    <div *ngIf="showActions" class="info" fxLayout="row" fxLayoutAlign="space-between start">
        <div fxFlex fxLayout="row" fxLayoutAlign="start center" class="h-48">
            <div class="time">{{note.note.dateCreated | date: 'dd/MMM/yyyy - hh:mm a'}}</div>
            <div class="time" style="padding-left:10px">{{ ((note.note.noteType?.name.length || 0)>0? '- '+
                note.note.noteType?.name:
                '')}}</div>
        </div>
        <button mat-icon-button [matMenuTriggerFor]="moreMenu" aria-label="More" class="mat-icon-button" matTooltip="More"
            (click)="$event.stopPropagation()">
            <mat-icon>more_vert</mat-icon>
        </button>

        <mat-menu #moreMenu="matMenu">
            <button mat-menu-item aria-label="Copy" [copy-clipboard]="note.note.detail" (copied)="notifyCopied($event)">
                <mat-icon>assignment</mat-icon>
                <span>Copy</span>
            </button>

            <button mat-menu-item aria-label="Print" (click)="print($event)">
                <mat-icon>print</mat-icon>
                <span>Print</span>
            </button>
        </mat-menu>
    </div>

    <div [innerHTML]="note.note.detail | safeHtml"></div>

</div>